import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from 'utils';

export const showPipelineStart = createAction(
  'SHOW_PIPELINE::START',
  withPayloadType<{ id: string; organizationId: string }>(),
);
